import React, { FC } from 'react';

import { useTranslation } from 'Modules/core/i18n';
import { Stub, Padlock24, Typography } from 'Modules/ui3';


export const AccessDeniedBanner: FC = () => {
    const { t } = useTranslation('accessDenied');
    return (
        <Stub
            title={t('title')}
            iconVariant='red'
            Icon={Padlock24}
            titleVariant='mediumHeader1'
        >
            <Typography variant='regularBody2' color='grayscale.shade85'>
                {t('message')}
            </Typography>
        </Stub>
    );
};
